import React from 'react';


function WordsFound(props) {

  if (props.found === undefined) {
    return null;
  }

  if (props.found.results === undefined) {
    return (<div>NONE FOUND</div>);
  }

  const wordlist = Object.keys(props.found.results).map((item, i) => {
    let keyName = 'wordlist' + i;
    return <WordList key={keyName} numChars={item} match={props.found.match} words={props.found.results[item]} />;
  });


  return (
    <div className="grid-x grid-padding-x">
    {wordlist}
    </div>
  );
}


function WordList(props) {

  const words = props.words.map((item, i) => {
    let keyName = 'wordlist' + i;

    if (item === props.match) {
      return <div key={keyName}><b>{item}</b></div>;
    }

    return <div key={keyName}>{item}</div>;
  });

  return (
    <div className="small-4 medium-3 large-2 cell wordlist">

      <div className="card">
        <div className="card-divider">
          {props.numChars} Letter Words
        </div>
        <div className="card-section">
          {words}
        </div>
      </div>
    </div>
  );
}


function WordMatchStatus(props) {

  if (props.found === undefined || props.found.match === undefined) {
    return null;
  }
  else if (props.found.match === false) {
    return null;

  }

  return (
    <i className="fa fa-2x fa-check-circle word-match-status" aria-hidden="true"></i>
  );
}


class WordFinder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.findWords = this.findWords.bind(this);
  }

  findWords(toFind, wordlist) {
    const matchingWords = {};
    let wordFound = false;
    wordlist.filter((word) => {
      if (word !== '' && word.substring(0, toFind.length) === toFind) {

        if (matchingWords[word.length] === undefined) {
          matchingWords[word.length] = [];
        }

        matchingWords[word.length].push(word);
        if (word === toFind ) {
          wordFound = toFind;
        }
        return word;
      }
      return false;
    });

    // sort the words alphabetically
    Object.keys(matchingWords).map((wordLength) => {
      matchingWords[wordLength].sort();
      return true;
    });

    // return matchingWords;
    return {
      results: matchingWords,
      match: wordFound,
    };
  }


  handleKeyDown(event) {
    // console.log('handleKeyDown');
    // const name = event.target.name;
    const value = event.target.value.toLowerCase();
    const myStateValues = this.state;

    if (value.length > 0) {

      let char = value[0];

      if (myStateValues['char'] === undefined || myStateValues['char'] !== char) {
        // do not have wordlist yet
        fetch('./data/' + char + '.txt')
          .then(response => {
            return response.text();
          })
          .then(wordlist => {

            myStateValues['char'] = char;
            myStateValues['wordlist'] = wordlist.split("\n");
            myStateValues['found'] = this.findWords(value, myStateValues['wordlist']);
            this.setState(myStateValues);
          })
          .catch((e) => {
            console.log(e);
          // should do something with exception
        });
      }
      else {
        myStateValues['found'] = this.findWords(value, myStateValues['wordlist']);
        this.setState(myStateValues);
      }

    }
    else {
      // clear it as empty string
      myStateValues['found'] = [];
      this.setState(myStateValues);
    }
  }

  render() {

    return (
      <div>
        <div className="app-header">
          <h2>Find a Scrabble Word</h2>
          <div className="float-center word-input">
              <input className="float-left" placeholder="Type word.." type="text" name="find" onKeyUp={this.handleKeyDown} />
              <WordMatchStatus found={this.state.found} />
          </div>
        </div>
        <div className="app-intro">
          <WordsFound found={this.state.found} />
        </div>
        <div className="app-footer">

            <p className="text-center">Word list from <a href="https://www.wordgamedictionary.com/sowpods">Word Game Dictionary SOWPODS Word List</a></p>

        </div>
      </div>
    );
  }
}

export default WordFinder;



// WEBPACK FOOTER //
// ./src/components/WordFinder.js